import AddConnector from "components/ConnectorType/AddConnector";
import ConnectorType from "components/ConnectorType/ConnectorType";
import DialogConnector from "components/ConnectorType/Model/DailogConnector";
import ConnectorExcelUpload from "pages/connectorType/ConnectorExcelUpload";
import React, { Component } from "react";
import { ConnectorApiData } from "stores/Connector/ConnectorApi";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import EditDeleteConnectorModel from "components/ConnectorType/Model/EditDeleteModel";
import Modal from "components/common/Modal";
import { Fade } from "@mui/material";
import Button from "components/common/Button";

function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class ConnectorTypeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Conector: true,
      AddConnector: false,
      renderComponent: "",
      open: false,
      dailogconnector: false,
      page: 0,
      limit: 100,
      formError: {},
      ErrorMsg: "",
      modelopen: false,
      addSuccess: false,
      connectordeleteopen: false,
      editconnectortype: "",
      editdata: "",
      inputsearch: "",
      filter:'',
      formData: {
        from_date: "",
        to_date: "",
      },
      updateSuccessOpen:false,
    };
    this.debouncedSearch = debounce(this.performSearch?.bind(this), 500);
  }
  performSearch(searchQuery) {
    if (searchQuery) {
      this.props.getConnectorData({search_term:searchQuery,limit:this.state.limit,  from_date: this.state.formData.from_date,
      filter: this.state.filter,
      to_date: this.state.formData.to_date,});
      return;
    } else this.props.getConnectorData({ limit: this.state.limit,  from_date: this.state.formData.from_date,
      filter: this.state.filter,
      to_date: this.state.formData.to_date,});
  }

  handleFilterApiData = async () => {
    await this.props.getConnectorData({
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      limit:this.state.limit
    });
  };
  handleReset = async () =>{
    await this.props.getConnectorData({
      limit:this.state.limit
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChangedate = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    this.handleFilterApiData();
    this.setState({ formData });
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  async componentDidMount() {
    const payload = {
      filter: "",
      limit: this.state.limit,
      page: this.state.page,
    };
    this.props.getConnectorData(payload);
  }
  handleModelClose = () => {
    this.setState({ modelopen: false });
  };
  handleModelOpen = () => {
    this.setState({ modelopen: true });
  };
  handleChangeConnector = (e) => {
    this.setState({
      filter: e.target.value,
    });
    if (e.target.value == "All") {
      this.props.getConnectorData("");
    } else {
      this.props.getConnectorData({
        // search_term: e.target.value,
        filter: e.target.value,
        limit: this.state.limit,
        page: this.state.page,
      });
    }
  };
  openDeleteConnector = () => {
    this.setState({ connectordeleteopen: true });
  };
  closeDeleteConnector = () => {
    this.setState({ connectordeleteopen: false });
  };

  openConnector = () => {
    this.setState({ dailogconnector: true });
  };
  closeConnector = () => {
    this.setState({ dailogconnector: false });
  };

  handleDeleteConnector = async (id) => {

    try {
      let res =  await  this.props.deleteconnectorsAction(id);
      const payload = {
        filter: "",
        search_term: "",
        limit: this.state.limit,
        page: this.state.page,
      };

      // if(res.status === 1){
      await this.props.getConnectorData(payload);
        this.closeDeleteConnector();
        this.props.toastAction({
          open: true,
          message: 'delete connector successfully',
          severity: "success",
        })
        
      // }
      
    } catch (error) {
      console.error("Error delete connector:", error);
    }

   
   
  };
  handleEditConnector = (type, data) => {
    
    this.setState({ editdata: data });

    if (type === "editconnector") {
      this.setState({ editconnectortype: type });
      this.openDeleteConnector();
    } else if (type === "deleteconnectortype") {
      this.setState({ editconnectortype: type });
      this.openDeleteConnector();
    } else {
      this.closeDeleteConnector();
    }
  };

  submitConnector = (data) => {
    ConnectorApiData.postConnectorData(data)
      .then((response) => {
        this.setState({ dailogconnector: true });
        const payload = {
          filter: "",
          search_term: "",
          limit: this.state.limit,
          page: this.state.page,
        };
        this.props.getConnectorData(payload);
      })
      .catch((error) => {
        console.error("Error posting connector data:", error);
      });
  };
  handleCloseUpdate=()=>{
    this.setState({updateSuccessOpen:false})
  }

  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpen = () => {
    this.setState({ open: true });
  };
  handleExcelSubmit = async (data) => {
    try {
      const res = await ConnectorApiData.postBulkData(data);

      if (res.status === 1) {
        this.setState({ open: false });
        this.setState({ addSuccess: true });
      }
    } catch (e) {
      console.log("e.error", e.error);
    }
  };

  handleAddConnnector = (addType) => {
    if (addType === "AddConnector") {
      this.setState({ renderComponent: "AddConnector" });
      this.setState({ Conector: false });
    } else {
      this.setState({ renderComponent: "" });
    }
  };

  handleChange = (value) => {
    const payload = {
      filter: value,
      limit: this.state.limit,
      page: this.state.page,
    };
    this.props.getConnectorData(payload);
  };
  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({ inputsearch:query });
    this.debouncedSearch(query);
  };

  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    const payload = {
      page: page,
      limit: rowsPerPage,
      filter: this.state.filter,
      search_term: this.state.inputsearch,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
    };
    this.props.getConnectorData(payload);
  };
  handleSubmitEditConnectot = async (data, id) => {
    
    try {
      let res=  await  ConnectorApiData.editConnectorApi(data, id);
      const payload = {
        filter: this.state.filter,
        search_term: this.state.inputsearch,
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
        limit: this.state.limit,
        page: this.state.page,
      };
      if(res.status===1){
        this.props.getConnectorData(payload);
        this.setState({updateSuccessOpen:true})

      }
      
    } catch (error) {
      console.error("Error editing connector:", error);
    }
  };

  render() {
    const connectordata = this.props.ConnectorDataList.result;
    switch (this.state.renderComponent) {
      case "AddConnector":
        return (
          <div>
            <AddConnector
              submitConnector={(val) => this.submitConnector(val)}
              handleAddConnnector={this.handleAddConnnector}
            />
            <DialogConnector
              closeConnector={this.closeConnector}
              open={this.state.dailogconnector}
            />
          </div>
        );
      default:
        return (
          <>
            <ConnectorType
              count={this.props.ConnectorDataList?.result?.count}
              searchhandleChange={this.searchhandleChange}
              handleEditConnector={this.handleEditConnector}
              openDeleteConnector={this.openDeleteConnector}
              handleOpen={this.handleModelOpen}
              handleClose={this.handleClose}
              limit={this.state?.limit}
              formData={this.state?.search_term}
              page={this.state?.page}
              handleAddConnnector={this.handleAddConnnector}
              ConnectorData={connectordata?.connectors?.reverse()}
              handleChangeConnnector={this.handleChangeConnector}
              onPageChange={this.onPageChange}
              isLoading={this.props.isLoading}
              onChange={this.handleChange}
              onDatePickerSub={this.onDatePickerSub}
              datePickerOpen={this.state.datePickerOpen}
              handleDatePickerOpen={this.handleDatePickerOpen}
              handleDatePickerClose={this.handleDatePickerClose}
              handleChangedate={this.handleChangedate}
              from_date={this.state.formData.from_date}
              to_date={this.state.formData.to_date}
              fromat_date_from={this.state.formData.fromat_date_from}
              fromat_date_to={this.state.formData.fromat_date_to}
              filterValue={this.state.filter}
              handleReset={this.handleReset}

            />
            <EditDeleteConnectorModel
              handleSubmitEditConnectot={this.handleSubmitEditConnectot}
              handleDeleteConnector={this.handleDeleteConnector}
              editdata={this.state.editdata}
              ConnectorData={connectordata}
              connectortypeopen={this.state.editconnectortype}
              open={this.state.connectordeleteopen}
              closeDeleteConnector={this.closeDeleteConnector}
            />
            <ConnectorExcelUpload
              open={this.state.modelopen}
              handleClose={this.handleModelClose}
              handleExcelSubmit={this.handleExcelSubmit}
            />
            <Snackbar
              open={this.state.addSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ addSuccess: false })}
              message="bulk add Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">bulk added Successfully</Alert>
            </Snackbar>

            <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      open={this.state.updateSuccessOpen}
                      onClose={this.handleCloseUpdate}
                      closeAfterTransition
                      size="xss"
                      // BackdropComponent={Backdrop}
                    >
                      <Fade in={this.state.updateSuccessOpen}>
                        <div style={{textAlign:'center'}} >
                          <img
                            src="../images/successful.svg"
                            alt="logo"
                            style={{ marginTop: "10px" }}
                          ></img>
                          <h4 id="transition-modal-title">Connector Updated Successfully</h4>
                          <Button variant="contained" color="primary" onClick={this.handleCloseUpdate} style={{ padding: '5px 50px', fontSize: "14px" }}>ok</Button>
                        </div>
                      </Fade>
                    </Modal>
          </>
        );
    }
  }
}
